@if (user$ | async; as user) {
  @if (client$ | async; as client) {
    @if (algemeneMeldingen$ | async; as algemeneMeldingen) {
      @if (clientMeldingen$ | async; as clientMeldingen) {
        <zah-client-header [client]="client"
          label="Meldingen">
        </zah-client-header>
        <div class="content">
          @if (algemeneMeldingen.length > 0 || canManageAlgemeneMeldingen(user)) {
            <zah-algemene-meldingen
              [algemeneMeldingen]="algemeneMeldingen"
              [user]="user"
              (algemeneMeldingEdited)="onAlgemeneMeldingEdited($event)"
              (algemeneMeldingDeleted)="onAlgemeneMeldingDeleted($event)"
              (algemeneMeldingAdded)="onAlgemeneMeldingAdded($event)">
            </zah-algemene-meldingen>
          }
          <zah-client-meldingen [clientMeldingen]="clientMeldingen"
            [user]="user"
            (clientMeldingEdited)="onClientMeldingEdited(client, $event)"
            (clientMeldingDeleted)="onClientMeldingDeleted(client, $event)"
            (clientMeldingAdded)="onClientMeldingAdded(client, $event)">
          </zah-client-meldingen>
          <button mat-mini-fab
            color="primary"
            class="back-button"
            (click)="navigateBack()">
            <mat-icon>arrow_back</mat-icon>
          </button>
        </div>
      }
    }
  }
}
